import { useSelector } from 'react-redux';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Box } from "@mui/material";

const DefaultFields = ({formData, handleChallanFormData, handleAttachmentChange, schemeLoading, department, screenType, totalAmount}) => {
    const { authData } = useSelector((state) => state.authData);
    return (
        <>
            {
                authData.user.department_details.is_multi === "1" && 
                <div className='col-md-4'>
                    <div className="form-group">
                        <label for="inputFinancial" className="col-form-label"> Select Department Code<span className="text-danger">*</span> :</label>
                        <select className="form-control " id="department_id"
                            name='department_id'
                            value={formData.department_id}
                            onChange={handleChallanFormData}
                            disabled={schemeLoading || screenType == "View"}
                            required
                        >
                            <option value="">Select Department Code</option>
                            {department.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            }
            
            <div className="col-md-4">
                <div className="form-group">
                    <label for="" className="col-form-label">Reappropriation Order No. <span className="text-danger">*</span> :</label>
                    <input type="text"
                        className="form-control"
                        name='reappropriate_order_no'
                        required
                        value={formData.reappropriate_order_no}
                        onChange={handleChallanFormData}
                        disabled={screenType == "View"} />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label for="" className="col-form-label">Reappropriation Order Date <span className="text-danger">*</span> :</label>
                    <input type="date"
                        className="form-control"
                        name='reappropriate_order_date'
                        required
                        value={formData.reappropriate_order_date}
                        onChange={handleChallanFormData}
                        disabled={screenType == "View"} />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label for="" className="col-form-label">Budget Reappropriation Order Value <span className="text-danger">*</span> :</label>
                    <input type="text"
                        className="form-control"
                        name='reappropriate_order_value'
                        required
                        value={totalAmount.current}
                        onChange={handleChallanFormData}
                        disabled={screenType == "View"} />
                </div>
            </div>
            <div className="col-md-4">
                <div className="input-group">
                    <label className="input-group-btn my-0 mt-2 mr-2">
                        Upload Document  <span className="text-danger">*</span>
                    </label><br />
                    {
                        screenType == "View" ? 
                        <Box sx={{ width: '100%', textAlign: 'center', marginRight: 2 }}>
                            <a href={formData.order_url} download={formData.order_url} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box sx={{ width: '100%', height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0f0f0', borderRadius: 0 }}><InsertDriveFileIcon fontSize="large" color="primary" /></Box>
                            </a>
                        </Box>
                        : <label className='p-1'>
                                <input id="" type="file"
                                    className='form-control'
                                    onChange={handleAttachmentChange}
                                    name='attachment'
                                    accept=".pdf,.jpeg,.jpg,.png"
                                    required
                                    multiple />
                            </label>
                    }
                    
                </div>
            </div>
        </>
    )
}

export default DefaultFields;